/* Opens a section of workspace Settings from anywhere a component can't navigate itself (one
   that renders outside the router too, in stories and tests). The app listens in `App.tsx`. */
export const OPEN_WORKSPACE_SETTINGS = "open-workspace-settings";

export const openWorkspaceSettings = (section: string) =>
  window.dispatchEvent(new CustomEvent(OPEN_WORKSPACE_SETTINGS, { detail: section }));
